export const headerInterceptor = (config) => {
	config.headers["X-Request-Tracking-Id"] = new Date().getTime();
	config.headers["X-Request-Session-Id"] = new Date().getTime();
	config.headers["Pragma"] = "no-cache";
	config.headers["Cache-Control"] = "no-cache, no-store";
	config.headers["Expires"] = new Date().getTime();
	return config;
};

export const handleHeaderInterceptorError = (error) => {
	return Promise.reject(error);
};
